var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as reportRepository from '../repositories/report-repository';
import { ReportGroupVisibilityStatus } from '../types/report-group-type';
import { handleResponse } from '../utils/ApiResponse';
export var getReportTypes = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getReportTypes(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, Promise.reject(error_1)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getReportTypeById = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getReportTypeById(id)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_2 = _a.sent();
                return [2 /*return*/, Promise.reject(error_2)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getReportTypeData = function (params, source) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getReportTypeData(params, source)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_3 = _a.sent();
                return [2 /*return*/, Promise.reject(error_3)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getReportTypeDataByPublisher = function (params, source) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getReportTypeDataByPublisher(params, source)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_4 = _a.sent();
                return [2 /*return*/, Promise.reject(error_4)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getFilterableFields = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getFilterableFields(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_5 = _a.sent();
                return [2 /*return*/, Promise.reject(error_5)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getReportGroups = function (publisherIds, visibility) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getReportGroups(publisherIds, visibility)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_6 = _a.sent();
                return [2 /*return*/, Promise.reject(error_6)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getReportGroupsById = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getReportGroupsById(id)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_7 = _a.sent();
                return [2 /*return*/, Promise.reject(error_7)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getPlatforms = function (publisherIds) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getPlatforms()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_8 = _a.sent();
                return [2 /*return*/, Promise.reject(error_8)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getPlatformsByPublisher = function (publisherId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getPlatformsByPublisher(publisherId)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_9 = _a.sent();
                return [2 /*return*/, Promise.reject(error_9)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getPlatformGroups = function (publisherIds) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getPlatformGroups(publisherIds)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_10 = _a.sent();
                return [2 /*return*/, Promise.reject(error_10)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getPlatformGroupsByLevel = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getPlatformGroupByLevel(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_11 = _a.sent();
                return [2 /*return*/, Promise.reject(error_11)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getAllPlatformGroupsByLevel = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getAllPlatformGroupByLevel(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_12 = _a.sent();
                return [2 /*return*/, Promise.reject(error_12)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getPlatformGroupDetails = function (platformGroupId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getPlatformGroupDetails(platformGroupId)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_13 = _a.sent();
                return [2 /*return*/, Promise.reject(error_13)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getPlatformInventories = function (publisherIds) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getPlatformInventoriesByPublisher(publisherIds)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_14 = _a.sent();
                return [2 /*return*/, Promise.reject(error_14)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getPubdeskInventories = function (publisherIds, mediaIds, labelIds) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getPubdeskInventories(publisherIds, mediaIds, labelIds)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_15 = _a.sent();
                return [2 /*return*/, Promise.reject(error_15)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var createReportGroup = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_16;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.createReportGroup(body)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_16 = _a.sent();
                return [2 /*return*/, Promise.reject(error_16)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateReportGroup = function (body, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_17;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.updateReportGroup(body, id)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_17 = _a.sent();
                return [2 /*return*/, Promise.reject(error_17)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var createReportType = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_18;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.createReportType(body)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_18 = _a.sent();
                return [2 /*return*/, Promise.reject(error_18)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateReportType = function (body, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_19;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.updateReportType(body, id)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_19 = _a.sent();
                return [2 /*return*/, Promise.reject(error_19)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getAllPlatforms = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_20;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getAllPlatforms(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_20 = _a.sent();
                return [2 /*return*/, Promise.reject(error_20)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var exportCSV = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_21;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.exportCSV(body)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_21 = _a.sent();
                return [2 /*return*/, Promise.reject(error_21)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var requiredDimension = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_22;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.requiredDimension(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_22 = _a.sent();
                return [2 /*return*/, Promise.reject(error_22)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var previewReportType = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_23;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.previewReportType(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_23 = _a.sent();
                return [2 /*return*/, Promise.reject(error_23)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var previewReportStackChart = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_24;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.previewReportStackChart(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_24 = _a.sent();
                return [2 /*return*/, Promise.reject(error_24)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getStackedBarChartData = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_25;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getStackedBarChartData(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_25 = _a.sent();
                return [2 /*return*/, Promise.reject(error_25)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getStackedBarChartDataByPublisher = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_26;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getStackedBarChartDataByPublisher(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_26 = _a.sent();
                return [2 /*return*/, Promise.reject(error_26)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var orderReportGroups = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_27;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.orderReportGroups(body)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_27 = _a.sent();
                return [2 /*return*/, Promise.reject(error_27)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getOrderedReportGroups = function (publisherId, visibility) { return __awaiter(void 0, void 0, void 0, function () {
    var params, response, error_28;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                params = {
                    publisherId: publisherId,
                    visibility: visibility !== null && visibility !== void 0 ? visibility : ReportGroupVisibilityStatus.ALL
                };
                return [4 /*yield*/, reportRepository.getOrderedReportGroups(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_28 = _a.sent();
                return [2 /*return*/, Promise.reject(error_28)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getComposedChartData = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_29;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getComposedChartData(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_29 = _a.sent();
                return [2 /*return*/, Promise.reject(error_29)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getComposedChartDataByPublisher = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_30;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getComposedChartDataByPublisher(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_30 = _a.sent();
                return [2 /*return*/, Promise.reject(error_30)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var previewReportComposedChart = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_31;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.previewReportComposedChart(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_31 = _a.sent();
                return [2 /*return*/, Promise.reject(error_31)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getDeviceCategory = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_32;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getDeviceCategory(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_32 = _a.sent();
                return [2 /*return*/, Promise.reject(error_32)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateDefaultSetting = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_33;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.updateDefaultSetting(data)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_33 = _a.sent();
                return [2 /*return*/, Promise.reject(error_33)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var loadDefaultSetting = function (publisherId, reportGroupId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_34;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.loadDefaultSetting(publisherId, reportGroupId)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_34 = _a.sent();
                return [2 /*return*/, Promise.reject(error_34)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var registerBigReportData = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_35;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.registerBigReportData(body)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_35 = _a.sent();
                return [2 /*return*/, Promise.reject(error_35)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var downloadReportJob = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_36;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.downloadReportJob()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_36 = _a.sent();
                return [2 /*return*/, Promise.reject(error_36)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getReportJob = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_37;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getReportJob(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_37 = _a.sent();
                return [2 /*return*/, Promise.reject(error_37)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var deleteReportJob = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_38;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.deleteReportJob(id)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_38 = _a.sent();
                return [2 /*return*/, Promise.reject(error_38)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var pinReportGroups = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_39;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.pinReportGroups(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_39 = _a.sent();
                return [2 /*return*/, Promise.reject(error_39)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getCalculatedDataStatus = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_40;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getCalculatedDataStatus(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_40 = _a.sent();
                return [2 /*return*/, Promise.reject(error_40)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var deleteReportType = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_41;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.deleteReportType(id)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_41 = _a.sent();
                return [2 /*return*/, Promise.reject(error_41)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getScheduleReport = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_42;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getScheduleReport(params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_42 = _a.sent();
                return [2 /*return*/, Promise.reject(error_42)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var createScheduleReport = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_43;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.createScheduleReport(body)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_43 = _a.sent();
                return [2 /*return*/, Promise.reject(error_43)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getScheduleReportById = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_44;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getScheduleReportById(id)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_44 = _a.sent();
                return [2 /*return*/, Promise.reject(error_44)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateScheduleReport = function (body, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_45;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.updateScheduleReport(body, id)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_45 = _a.sent();
                return [2 /*return*/, Promise.reject(error_45)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getHiddenReportGroupIds = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_46;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.getHiddenReportGroupIds()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_46 = _a.sent();
                return [2 /*return*/, Promise.reject(error_46)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateReportGroupVisibility = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_47;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.updateReportGroupVisibility(body)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_47 = _a.sent();
                return [2 /*return*/, Promise.reject(error_47)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var deleteReportGroupVisibility = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_48;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, reportRepository.deleteReportGroupVisibility(body)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
            case 2:
                error_48 = _a.sent();
                return [2 /*return*/, Promise.reject(error_48)];
            case 3: return [2 /*return*/];
        }
    });
}); };
